/*-------------  SLIDE 3 animation  -------------*/

var s3headList = new Array();

function slide3_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';

	 $(".slide").html('');

		bmcont = '<div id="moveHome"></div><div id="sl3_cnt" class="s3_cnt"></div><div id="sl3_foo" class="menu_bott"></div><div id="slide_list1" class="slide1"></div><div id="slide_list2" class="slide1"></div><div id="slide_list3" class="slide1"></div><div id="slide_list4" class="slide1"></div><div id="slide_list5" class="slide1"></div>';

		$("#slide3").html(bmcont);

		homepage = '<div id="moveHead"><span class="head-icon"></span><h1>'+jsondata["sl3_head"]+'</h1></div>';
		$("#moveHome").html(homepage);

    $('#slide3').fadeIn(1000);

    returnHome('#moveHome','.slide','');

    bmcont = '<div class="menu"><ol class="menu-list">';
    pocet = jsondata["sl3_headline"].length + 1;
    for (i=1; i<pocet; i++) {
      bmcont += '<li id="list'+i+'" class="list-menu">'+jsondata["sl3_headline"][i-1]+'</li>';
      s3headList[i] = jsondata["sl3_headline"][i-1];
    }
		bmcont += '</ol></div><div class="footer"></div>';

    $("#sl3_cnt").html(bmcont);

    list_menuList();
}

function list1_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">I. ' + s3headList[1] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide31"><div  class="papir">';
    pocet = jsondata["sl31_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label31_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl31_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label31_1').fadeIn(500);

    /*bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl31_banner"].length;
    for (i=0; i<pocet; i++) {
      bmcont += jsondata["sl31_banner"][i];
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);*/

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label31_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        var id = $(this).attr("id");
        //var id = $(".slide_label_box").attr("id");
        switch (id) {
  			case "s31_2_list_n":
          $('#od_31_2 .icon_odpoved i').removeClass("icon_off");
          $('#od_31_2 .icon_odpoved i').addClass("icon_on");
          $('#od_31_2').css("color","#0071bc");
  			break;
  			case "s31_3_list_help":
          $('#slide_label31_3 .napoveda').fadeIn(500);
  			break;
  		  };
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s31_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label31_2').fadeIn(500);
			break;
			case "s31_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label31_3').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s31_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label31_1').fadeIn(500);
			break;
			case "s31_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label31_2').fadeIn(500);
			break;
		  };
    });
}

function list2_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">II. ' + s3headList[2] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide32"><div  class="papir">';
    pocet = jsondata["sl32_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label32_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl32_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label32_1').fadeIn(500);

    /*bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl32_banner"].length;
    for (i=0; i<pocet; i++) {
      bmcont += jsondata["sl32_banner"][i];
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);*/

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        var id = $(this).attr("id");
        switch (id) {
  			case "s32_8_list_help":
          $('.napovedaoff').fadeOut(1);
          $('#od_32_5 .icon_odpoved i').removeClass("icon_off");
          $('#od_32_5 .icon_odpoved i').addClass("icon_on");
          $('#od_32_5').css("color","#0071bc");
  			break;
  		  };
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s32_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_2').fadeIn(500);
			break;
			case "s32_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_3').fadeIn(500);
			break;
      case "s32_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_4').fadeIn(500);
			break;
      case "s32_4_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_5').fadeIn(500);
			break;
      case "s32_5_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_6').fadeIn(500);
			break;
      case "s32_6_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_7').fadeIn(500);
			break;
      case "s32_7_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_8').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s32_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label32_1').fadeIn(500);
			break;
			case "s32_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_2').fadeIn(500);
			break;
      case "s32_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_3').fadeIn(500);
			break;
      case "s32_5_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_4').fadeIn(500);
			break;
      case "s32_6_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_5').fadeIn(500);
			break;
      case "s32_7_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_6').fadeIn(500);
			break;
      case "s32_8_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label32_7').fadeIn(500);
			break;
		  };
    });
}

function list3_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">III. ' + s3headList[3] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide33"><div  class="papir">';
    pocet = jsondata["sl33_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label33_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl33_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label33_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s33_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_2').fadeIn(500);
			break;
			case "s33_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_3').fadeIn(500);
			break;
      case "s33_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_4').fadeIn(500);
			break;
      case "s33_4_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_5').fadeIn(500);
			break;
      case "s33_5_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_6').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s33_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label33_1').fadeIn(500);
			break;
			case "s33_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_2').fadeIn(500);
			break;
      case "s33_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_3').fadeIn(500);
			break;
      case "s33_5_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_4').fadeIn(500);
			break;
      case "s33_6_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label33_5').fadeIn(500);
			break;
		  };
    });
}

function list4_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">IV. ' + s3headList[4] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide34"><div  class="papir">';
    pocet = jsondata["sl34_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label34_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl34_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label34_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s34_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_2').fadeIn(500);
			break;
			case "s34_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_3').fadeIn(500);
			break;
      case "s34_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_4').fadeIn(500);
			break;
      case "s34_4_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_5').fadeIn(500);
			break;
      case "s34_5_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_6').fadeIn(500);
			break;
      case "s34_6_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_7').fadeIn(500);
			break;
      case "s34_7_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_8').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s34_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label34_1').fadeIn(500);
			break;
			case "s34_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_2').fadeIn(500);
			break;
      case "s34_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_3').fadeIn(500);
			break;
      case "s34_5_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_4').fadeIn(500);
			break;
      case "s34_6_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_5').fadeIn(500);
			break;
      case "s34_7_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_6').fadeIn(500);
			break;
      case "s34_8_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label34_7').fadeIn(500);
			break;
		  };
    });
}

function list5_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">V. ' + s3headList[5] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide35"><div  class="papir">';
    pocet = jsondata["sl35_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label35_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl35_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label35_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label35_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s35_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label35_2').fadeIn(500);
			break;
			case "s35_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label35_3').fadeIn(500);
			break;
      case "s35_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label35_4').fadeIn(500);
			break;
      case "s35_4_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label35_5').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s35_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label35_1').fadeIn(500);
			break;
			case "s35_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label35_2').fadeIn(500);
			break;
      case "s35_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label35_3').fadeIn(500);
			break;
      case "s35_5_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label35_4').fadeIn(500);
			break;
      };
    });
}

function list6_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">VI. ' + s3headList[6] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide36"><div  class="papir">';
    pocet = jsondata["sl36_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label36_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl36_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label36_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label36_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s36_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label36_2').fadeIn(500);
			break;
			case "s36_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label36_3').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s36_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label36_1').fadeIn(500);
			break;
			case "s36_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label36_2').fadeIn(500);
			break;
		  };
    });
}

function list7_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">VII. ' + s3headList[7] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide37"><div  class="papir">';
    pocet = jsondata["sl37_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label37_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl37_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label37_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label37_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s37_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label37_2').fadeIn(500);
			break;
			case "s37_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label37_3').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s37_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label37_1').fadeIn(500);
			break;
			case "s37_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label37_2').fadeIn(500);
			break;
		  };
    });
}

function list8_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">VIII. ' + s3headList[8] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide38"><div  class="papir">';
    pocet = jsondata["sl38_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label38_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl38_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label38_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label38_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        var id = $(this).attr("id");
        switch (id) {
  			case "s38_4_list_help":
          $('#od_38_2 .icon_odpoved i').removeClass("icon_off");
          $('#od_38_2 .icon_odpoved i').addClass("icon_on");
          $('#od_38_2').css("color","#0071bc");
  			break;
  		  };
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s38_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label38_2').fadeIn(500);
			break;
			case "s38_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label38_3').fadeIn(500);
			break;
      case "s38_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label38_4').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s38_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label38_1').fadeIn(500);
			break;
			case "s38_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label38_2').fadeIn(500);
			break;
      case "s38_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label38_3').fadeIn(500);
			break;
		  };
    });
}

function list9_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">IX. ' + s3headList[9] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide39"><div  class="papir">';
    pocet = jsondata["sl39_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label39_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl39_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label39_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        var id = $(this).attr("id");
        switch (id) {
  			case "s39_3_list_help":
          $('#od_39_1 .icon_odpoved i').removeClass("icon_off");
          $('#od_39_1 .icon_odpoved i').addClass("icon_on");
          $('#od_39_1').css("color","#0071bc");
          $('#od_39_6 .icon_odpoved i').removeClass("icon_off");
          $('#od_39_6 .icon_odpoved i').addClass("icon_on");
          $('#od_39_6').css("color","#0071bc");
  			break;
  		  };
        $('.napovedaoff').fadeOut(1);
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s39_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_2').fadeIn(500);
			break;
			case "s39_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_3').fadeIn(500);
			break;
      case "s39_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_4').fadeIn(500);
			break;
      case "s39_4_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_5').fadeIn(500);
			break;
      case "s39_5_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_6').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s39_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label39_1').fadeIn(500);
			break;
			case "s39_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_2').fadeIn(500);
			break;
      case "s39_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_3').fadeIn(500);
			break;
      case "s39_5_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_4').fadeIn(500);
			break;
      case "s39_6_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label39_5').fadeIn(500);
			break;
		  };
    });
}

function list10_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">X. ' + s3headList[10] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide40"><div  class="papir">';
    pocet = jsondata["sl40_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label40_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl40_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label40_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label40_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s40_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label40_2').fadeIn(500);
			break;
			case "s40_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label40_3').fadeIn(500);
			break;
      case "s40_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label40_4').fadeIn(500);
			break;
      case "s40_4_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label40_5').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s40_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label40_1').fadeIn(500);
			break;
			case "s40_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label40_2').fadeIn(500);
			break;
      case "s40_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label40_3').fadeIn(500);
			break;
      case "s40_5_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label40_4').fadeIn(500);
			break;
		  };
    });
}

function list11_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">XI. ' + s3headList[11] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide41"><div  class="papir">';
    pocet = jsondata["sl41_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label41_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl41_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label41_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        var id = $(this).attr("id");
        switch (id) {
  			case "s38_4_list_help":
          $('#od_38_2 .icon_odpoved i').removeClass("icon_off");
          $('#od_38_2 .icon_odpoved i').addClass("icon_on");
          $('#od_38_2').css("color","#0071bc");
  			break;
        case "s41_2_list_help":
          $('.kontainery .obr-full').fadeIn(500);
          $('.kontainery .obr-empty').fadeOut(100);
  			break;
  		  };
        $('.napovedaoff').fadeOut(1);
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s41_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_2').fadeIn(500);
			break;
			case "s41_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_3').fadeIn(500);
			break;
      case "s41_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_4').fadeIn(500);
			break;
      case "s41_4_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_5').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s41_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label41_1').fadeIn(500);
			break;
			case "s41_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_2').fadeIn(500);
			break;
      case "s41_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_3').fadeIn(500);
			break;
      case "s41_5_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_4').fadeIn(500);
			break;
      case "s41_6_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label41_5').fadeIn(500);
			break;
		  };
    });
}
/*
function list12_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">XII. ' + s3headList[12] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide42"><div  class="papir">';
    pocet = jsondata["sl42_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label42_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl42_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label42_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label42_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s42_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label42_2').fadeIn(500);
			break;
			case "s42_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label42_3').fadeIn(500);
			break;
      case "s42_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label42_4').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s42_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label42_1').fadeIn(500);
			break;
			case "s42_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label42_2').fadeIn(500);
			break;
      case "s42_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label42_3').fadeIn(500);
			break;
		  };
    });
}*/

function list12_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];

	  $(".slide1").html('');
    $('.napoveda').fadeOut(100);
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl3_list1_cnt" class="s3_list1_cnt"></div><div id="kapka"></div><div id="sl3_foo" class="menu_bott"></div>';
		$("#slide_list1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl3_head_list"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_list1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');
    bmcont = '<div class="hometitle"><div class="hometitleText">XII. ' + s3headList[12] + '</div></div>';

    $("#sl3_list1_cnt").html(bmcont);

    bslide = '<div id="detailSlide43"><div  class="papir">';
    pocet = jsondata["sl43_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label43_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl43_steps"][i-1]+"</div>";
    }
    bslide += '<div class=\"slide_close\"></div></div></div>';
    bmcont += bslide;

    $("#sl3_list1_cnt").html(bmcont);
    $('#slide_label43_1').fadeIn(500);

    $(".moveSlideNextStart").on("click", function(){
        $('.slide_label_box').fadeOut(100);
        $('#slide_label43_2').fadeIn(500);
        $('.hometitleText').fadeIn(500);
    });

    $(".otaznik").on("click", function(){
        $('.napovedaoff').fadeOut(1);
        $('.napoveda').fadeIn(500);
    });

    $(".odpovedi").on("click", function(){
      var id = $(this).attr("id");
      var stav = $('#'+id+' .icon_odpoved i').attr("class");
      if (stav == "icon_off") {
        $('#'+id+' .icon_odpoved i').removeClass("icon_off");
        $('#'+id+' .icon_odpoved i').addClass("icon_on");
      } else {
        $('#'+id+' .icon_odpoved i').removeClass("icon_on");
        $('#'+id+' .icon_odpoved i').addClass("icon_off");
      }

    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s43_1_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label43_2').fadeIn(500);
			break;
			case "s43_2_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label43_3').fadeIn(500);
			break;
      case "s43_3_list_n":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label43_4').fadeIn(500);
			break;
      case "s43_4_list_n":
        $('.napovedaoff').fadeIn(1);
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label43_5').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s43_2_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('.hometitleText').fadeOut(500);
        $('#slide_label43_1').fadeIn(500);
			break;
			case "s43_3_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label43_2').fadeIn(500);
			break;
      case "s43_4_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label43_3').fadeIn(500);
			break;
      case "s43_5_list_p":
        $('.napoveda').fadeOut(100);
        $('.slide_label_box').fadeOut(100);
        $('#slide_label43_4').fadeIn(500);
			break;
		  };
    });
}
